import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class HodinoveSazbyProvider extends BaseApi {
	async fetchSazbyZaklad(params: Record<string, any>) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetHSZaklad`, params);
	}

	async saveTable(table: any) {
		return this.update(`/${DMS_MODULE}/${NAME}`, table);
	}
}

export const apiProvider = new HodinoveSazbyProvider(DMS_MODULE, NAME);
